import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainLayout from "./layouts/MainLayout"; // Import the MainLayou

import './App.css'; 
import Login from "./components/Login/Login";
import Signup from "./components/Signup/Signup";
import Forget from "./components/Reset/Forget";
import Locations from "./pages/Location";
import Profitability from "./pages/Profitability";
import Transactions from "./pages/Transactions";
import Settings from "./pages/Settings";
import Support from "./pages/Support";
import Sessions from "./pages/Sessions";
import SessionCard from "./pages/SessionCard";
import Addhand from "./pages/Addhand";
import Preflop from "./pages/Preflop";
import Flop from "./pages/Flop";
import Turn from "./pages/Turn";
import River from "./pages/River";
import Showdown from "./pages/Showdown";
import Bankroll from "./pages/Bankroll"
import Reset from "./components/Reset/Reset";

function App() { 
  return (
    <Router> 
      <Routes>
        <Route path="/" element={<Login/>} />
        <Route path="/Signup" element={<Signup/>} />
        <Route path="/Forget" element={<Forget/>} />
        <Route path="/ResetPassword/:token" element={<Reset/>} />
        <Route path="/Locations" element={<MainLayout><Locations/></MainLayout>}/>
        <Route path="/BankRoll" element={<MainLayout><Bankroll/></MainLayout>}/>
        <Route path="/Profitability" element={<MainLayout><Profitability/></MainLayout>}/>
        <Route path="/Transactions" element={<MainLayout><Transactions/></MainLayout>}/>
        <Route path="/Settings" element={<MainLayout><Settings/></MainLayout>} />
        <Route path="/Support" element={<MainLayout><Support/></MainLayout>} />
        <Route path="/Sessions" element={<MainLayout><Sessions/></MainLayout>} />
        <Route path="/Sessions/SessionCard/:id" element={<MainLayout><SessionCard/></MainLayout>} />
        <Route path="/Sessions/SessionCard/addhand/:id" element={<MainLayout><Addhand/></MainLayout>} />
        <Route path="/Sessions/SessionCard/preflop/:id" element={<MainLayout><Preflop/></MainLayout>} />
        <Route path="/Sessions/SessionCard/flop/:id" element={<MainLayout><Flop/></MainLayout>} />
        <Route path="/Sessions/SessionCard/turn/:id" element={<MainLayout><Turn/></MainLayout>} />
        <Route path="/Sessions/SessionCard/river/:id" element={<MainLayout><River/></MainLayout>} />
        <Route path="/Sessions/SessionCard/showdown/:id" element={<MainLayout><Showdown/></MainLayout>} />
      </Routes>
    </Router>
  );
}

export default App;
